import React from 'react';
import { RotationPortCall } from 'src/types/ViewModel/Stowage/Rotation/RotationPortCall';
import { RotationBerthCall } from 'src/types/ViewModel/Stowage/Rotation/RotationBerthCall';
import { getBerthCalls } from 'src/utils/stowage/stowageRotationUtils';

type Props = {
    rotation: RotationPortCall[] | null;
    onSelectedPortCall: (portCall: RotationPortCall) => void;
    onSelectedBerthCall: (berthCall: RotationBerthCall) => void;
    selectedPortCall: RotationPortCall | null;
    selectedBerthCall: RotationBerthCall | null;
};

const RotationDropDown: React.FC<Props> = (props) => {
    const onSelectBlockTankPortCall = (event: any, portCall: RotationPortCall) => {
        event.stopPropagation();
        event.preventDefault();
        props.onSelectedPortCall(portCall);
    };

    const onSelectBlockTankBerthCall = (event: any, berthCall: RotationBerthCall) => {
        event.stopPropagation();
        event.preventDefault();
        props.onSelectedBerthCall(berthCall);
    };

    return (
        <>
            {props.rotation && props.rotation.length > 0 && (
                <ul className="port-call-list">
                    {props.rotation.map((portCall) => {
                        return (
                            <li onClick={(e) => onSelectBlockTankPortCall(e, portCall)} key={'port-call' + portCall.portCallGuid}>
                                {portCall && (
                                    <>
                                        <div
                                            className={
                                                'port-call-name ' +
                                                (props.selectedPortCall?.portCallGuid === portCall.portCallGuid && !props.selectedBerthCall
                                                    ? 'selected'
                                                    : '')
                                            }
                                        >
                                            {portCall.portDisplayName}
                                        </div>
                                        {portCall.berthCalls && getBerthCalls(portCall).length > 0 && (
                                            <ul className="berth-call-list">
                                                {getBerthCalls(portCall).map((berthCall) => {
                                                    return (
                                                        <li
                                                            className={
                                                                props.selectedBerthCall?.berthCallGuid === berthCall.berthCallGuid ? 'selected' : ''
                                                            }
                                                            onClick={(e) => onSelectBlockTankBerthCall(e, berthCall)}
                                                            key={'berth-call' + berthCall.berthCallGuid}
                                                        >
                                                            {berthCall.berthName}
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        )}
                                    </>
                                )}
                            </li>
                        );
                    })}
                </ul>
            )}
        </>
    );
};

export default RotationDropDown;
